import EntryRegedit from "./EntryRegedit";
import FunctionItem from "./functionItem";
import MenuItem from "./menuItem";
import Tenant from "./tenant";
import User from "./user";
export default class App {
    public functionItems: FunctionItem[];
    public menuItems: MenuItem[];
    public entryRegedit: EntryRegedit[];
    public tenant: Tenant;
    public user: User;
    public enumData: any;
    constructor({
        menuItems = [],
        tenant = new Tenant({}),
        user = new User({}),
        functionItems = [],
        entryRegedit=[],
        enumData = {}
    }={}) {
        this.functionItems = functionItems||[];
        this.menuItems = menuItems||[];
        this.entryRegedit = entryRegedit||[];
        this.tenant = tenant;
        this.user = user;
        this.enumData = enumData
    }
}